module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-player-placeholder"
  }, [_c('div', {
    staticClass: "side-player-placeholder__wrapper"
  }, [_c('div', {
    staticClass: "player_text"
  }, [_vm._v("Hear What's Trending")]), _vm._v(" "), _c('v-btn', {
    staticClass: "cta__wrapper cursor-pointer cta__text",
    attrs: {
      "round": "",
      "dark": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.loadFeeds('discover', 1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "src": require("../assets/triangle-down.svg"),
      "width": "15"
    }
  }), _vm._v("\n          Surprise me\n        ")])], 1), _vm._v(" "), (_vm.isPlaying) ? _c('div', {
    staticClass: "side-player-placeholder__action"
  }, [_c('img', {
    staticClass: "_previous",
    attrs: {
      "src": require('@/assets/ic_rewind_outline.svg'),
      "alt": "previous button"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_play",
    attrs: {
      "src": require('@/assets/ic_play_outline.svg'),
      "alt": "play button"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_skip",
    attrs: {
      "src": require('@/assets/ic_skip_outline.svg'),
      "alt": "skip button"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9139795a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sideAudioPlaceholder.vue
// module id = 1811
// module chunks = 180